import type {
  ColorPreviewMapping,
  Product,
} from '@maestro/commerce-blocks/components/color-previews/color-previews.types'

import { useMemo } from 'react'

import { theme } from '@maestro/local/theme'

export const useColorPreviews = (product: Product) => {
  const { colorConfig } = theme()
  const colorPreviewMapping: ColorPreviewMapping =
    colorConfig.colorPreviewMapping

  const uniqueColors = useMemo(() => {
    if (!product.variants) {
      return []
    }
    return getUniqueColors(product.variants)
  }, [product.variants])

  return {
    uniqueColors,
    colorPreviewMapping,
  }
}

const getUniqueColors = (variants: Product['variants']) => {
  const colors = variants.flatMap((variant) =>
    variant.attributes.filter((attribute) => attribute.name === 'color')
  )
  return Array.from(new Set(colors.map((color) => color.value)))
}
